const DownloadType = {
	All: {
		key: 'All',
		text: 'All',
		doShowIfZero: true,
	},
	DownloadedNotReviewed: {
		key: 'DownloadedNotReviewed',
		text: 'Downloaded, Not Reviewed',
	},
	DownloadedReviewed: {
		key: 'DownloadedReviewed',
		text: 'Downloaded, Reviewed',
	},
};

export default DownloadType;
